/* Evertaste nav: desktop hover-open for header dropdowns.
   Parent titles are real links (see header-dropdown-menu.liquid), so the
   dropdown opens on hover; clicking the title navigates. Touch devices keep
   Dawn's native tap-to-toggle behavior. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.header__inline-menu header-menu > details').forEach(function (details) {
    var closeTimer;

    details.parentElement.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      details.setAttribute('open', '');
    });

    details.parentElement.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });
  });
})();
